import { useState } from 'react'
import MinMax from './MinMax'
import NetIncome from './NetIncome'

const ReportingWrapper = ({ minMaxData, netIncomeData }) => {
    const tabNames = {
        MIN_MAX: 'MIN_MAX',
        NET_INCOME: 'NET_INCOME'
    }

    const [currentTab, setCurrentTab] = useState(tabNames.MIN_MAX)

    return (
        <div className="content-width-container" style={{ padding: 0 }}>
            <div className="tabs-wrapper">
                <button
                    className={`tab ${currentTab === tabNames.MIN_MAX ? 'active' : ''}`}
                    onClick={() => setCurrentTab(tabNames.MIN_MAX)}
                >
                    Balance
                </button>

                <button
                    className={`tab ${currentTab === tabNames.NET_INCOME ? 'active' : ''}`}
                    onClick={() => setCurrentTab(tabNames.NET_INCOME)}
                >
                    Net Income
                </button>
            </div>
            
        {currentTab === tabNames.MIN_MAX && <MinMax data={minMaxData} />}
            {currentTab === tabNames.NET_INCOME && <NetIncome data={netIncomeData} />}
        </div>
    )
}

export default ReportingWrapper